import React from "react";
import { Button } from "@mui/material";
import useStyles from "./FmTextButton.style";

interface FmTextButtonProps {
  children: React.ReactNode | string;
  onClick?: () => void;
  className?: string;
}

const FmTextButton = ({ children, className, onClick }: FmTextButtonProps) => {
  const classes = useStyles();

  return (
    <Button variant="text" className={className} onClick={onClick}>
      {children}
    </Button>
  );
};

export default FmTextButton;
